<template lang="pug">
  b-container(fluid="lg")
    AssignmentRequestStateCards
    .tabla.sombra
      ListDriverAssignmentRequests
</template>

<script>
import ListDriverAssignmentRequests from '../components/assignment/ListDriverAssignmentRequests.vue'
import AssignmentRequestStateCards from '../components/assignment/AssignmentRequestStateCards.vue'
export default {
  components: {
    ListDriverAssignmentRequests,
    AssignmentRequestStateCards
  },
  data() {
    return {
    }
  }
}
</script>
